import { useQuota } from './api';

/** Фолбэки совпадают с дефолтами секции Retention в appsettings.json. */
const FALLBACK = { mailboxTrashDays: 30, messageTrashDays: 7 };

/** Сроки хранения в корзине, приходят из /api/v1/quota и настраиваются на бэкенде. */
export function useRetention() {
  const quota = useQuota();
  return quota.data?.retention ?? FALLBACK;
}
